module.exports = __webpack_public_path__ + "media/15.c9addb64.mp3";